const types = [
  { name: 'youtube', regex: /https?:\/\/((([^.]+\.)?youtube\.com)|(youtu.be))/ }
]

export default {
  getType: function (url) {
    for (let i = 0; i < types.length; i++) {
      if (types[i].regex.test(url)) {
        return types[i].name
      }
    }

    return null
  },

  isVideo: function (url) {
    return this.getType(url) !== null
  }
}
